"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZSZDBar = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
var swr_1 = __importDefault(require("swr"));
var quote_1 = require("../../modules/quote");
var config_1 = require("../../modules/quote/config");
var layout_1 = require("../page/shared/layout");
/**
 * 指数涨跌数量条
 * @returns
 */
function ZSZDBar() {
    var quotecode_list = ['1.000001', '0.399001', '0.399006', '0.399330'];
    var _a = (0, swr_1.default)("ZSZDBar_".concat(quotecode_list.toString()), function () { return (0, quote_1.getListQuoteOrFS)({
        quotecode_list: quotecode_list,
        itemlist: [
            config_1.QuoteItem.板块或指数上涨数量,
            config_1.QuoteItem.板块或指数下跌数量,
            config_1.QuoteItem.板块或指数平数量
        ],
    }); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _a.data, error = _a.error;
    if (data) {
        return (react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement("div", { className: "zszdbar" },
                    "\u4E0A\u6DA8", data === null || data === void 0 ? void 0 :
                    data[0][config_1.QuoteItem.板块或指数上涨数量].html,
                    "\u5BB6 | \u5E73\u76D8", data === null || data === void 0 ? void 0 :
                    data[0][config_1.QuoteItem.板块或指数平数量].html,
                    "\u5BB6 | \u4E0B\u8DCC", data === null || data === void 0 ? void 0 :
                    data[0][config_1.QuoteItem.板块或指数下跌数量].html,
                    "\u5BB6")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement("div", { className: "zszdbar" },
                    "\u4E0A\u6DA8", data === null || data === void 0 ? void 0 :
                    data[1][config_1.QuoteItem.板块或指数上涨数量].html,
                    "\u5BB6 | \u5E73\u76D8", data === null || data === void 0 ? void 0 :
                    data[1][config_1.QuoteItem.板块或指数平数量].html,
                    "\u5BB6 | \u4E0B\u8DCC", data === null || data === void 0 ? void 0 :
                    data[1][config_1.QuoteItem.板块或指数下跌数量].html,
                    "\u5BB6")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement("div", { className: "zszdbar" },
                    "\u4E0A\u6DA8", data === null || data === void 0 ? void 0 :
                    data[2][config_1.QuoteItem.板块或指数上涨数量].html,
                    "\u5BB6 | \u5E73\u76D8", data === null || data === void 0 ? void 0 :
                    data[2][config_1.QuoteItem.板块或指数平数量].html,
                    "\u5BB6 | \u4E0B\u8DCC", data === null || data === void 0 ? void 0 :
                    data[2][config_1.QuoteItem.板块或指数下跌数量].html,
                    "\u5BB6")),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement("div", { className: "zszdbar" },
                    "\u4E0A\u6DA8", data === null || data === void 0 ? void 0 :
                    data[3][config_1.QuoteItem.板块或指数上涨数量].html,
                    "\u5BB6 | \u5E73\u76D8", data === null || data === void 0 ? void 0 :
                    data[3][config_1.QuoteItem.板块或指数平数量].html,
                    "\u5BB6 | \u4E0B\u8DCC", data === null || data === void 0 ? void 0 :
                    data[3][config_1.QuoteItem.板块或指数下跌数量].html,
                    "\u5BB6"))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.ZSZDBar = ZSZDBar;
